import { useState } from "react";
import {
  Button,
  ButtonSizes,
} from "../../../../../components/core/Button/Button";
import { ReactComponent as CheckIcon } from "../../../../../icons/check.svg";
import { ReactComponent as SendIcon } from "../../../../../icons/send.svg";
import { PopupConfirm } from "../../../../../components/PopupConfirm/PopupConfirm";
import {
  APPROVED_CV_CONFIRMATION_MESSAGE,
  APPROVED_CV_LABEL,
  CONFIRM_TO_PC_LABEL,
  CONFIRM_VALID_LABEL,
  SEND_PROFILE_TO_PC,
  SUBMIT_TO_PC_CONFRIMATION_MESSAGE,
} from "../../../../../constants/Dictionary";

type ConfirmHistoryApprovalProps = {
  disabled?: boolean;
  isMyProfile?: boolean;
  onConfirm: () => Promise<void>;
  isLoading?: boolean;
};
export const ConfirmHistoryApproval = ({
  isMyProfile,
  disabled,
  onConfirm,
  isLoading,
}: ConfirmHistoryApprovalProps) => {
  const [showPopup, setShowPopup] = useState(false);

  const popupLabel = isMyProfile ? CONFIRM_TO_PC_LABEL : APPROVED_CV_LABEL;
  const popupMessage = isMyProfile
    ? SUBMIT_TO_PC_CONFRIMATION_MESSAGE
    : APPROVED_CV_CONFIRMATION_MESSAGE;
  const popupHeaderTitle = isMyProfile
    ? SEND_PROFILE_TO_PC
    : CONFIRM_VALID_LABEL;

  const handleConfirm = async () => {
    await onConfirm();
    setShowPopup(false);
  };

  return (
    <>
      <Button
        label={popupLabel}
        onClick={() => setShowPopup(true)}
        icon={isMyProfile ? <SendIcon /> : <CheckIcon />}
        size={ButtonSizes.REGULAR}
        disabled={disabled || isLoading}
      />

      <PopupConfirm
        isOpen={showPopup}
        label={popupHeaderTitle}
        popupText={popupMessage}
        onConfirm={handleConfirm}
        onCancel={() => setShowPopup(false)}
        isLoading={isLoading}
      />
    </>
  );
};
